export { default } from './Labs.component';
